import React, { useEffect, useState } from 'react'
import axios from "axios";
import { useLocation } from 'react-router-dom';
import { UserTokenURL } from '../../../services/ApiHIS';
import { postPrincipalFormasFarmaceuticas } from '../../../services/ApiSuministros';
import Loading from '../../Loading';
import ModalCrearFormasFarmaceuticas from './ModalCrearFormasFarmaceuticas';
import ModalConsultarFormasFarmaceuticas from './ModalConsultarFormasFarmaceuticas';
import ModalModificarFormasFarmaceuticas from './ModalModificarFormasFarmaceuticas';
import ModalConfirmarEliminarFormasFarmaceuticasYViasAplicacion from './ModalConfirmarEliminarFormasFarmaceuticasYViasAplicacion';

const FormasFarmaceuticasPrincipal = () => {
    const [dataFormasFarmaceuticas, setdataFormasFarmaceuticas]=useState([])
    const [loading, setloading]=useState(true)
    const [modalOnCrearFormasFarmaceuticas, setmodalOnCrearFormasFarmaceuticas]=useState(false)
    const [modalOnConsultarFormasFarmaceuticas, setmodalOnConsultarFormasFarmaceuticas]=useState(false)
    const [modalOnModificarFormasFarmaceuticas, setmodalOnModificarFormasFarmaceuticas]=useState(false)
    const [modalOnEliminarFormasFarmaceuticas, setmodalOnEliminarFormasFarmaceuticas]=useState(false)
    const [dataUnaFormaFarmaceutica, setdataUnaFormaFarmaceutica]=useState('')
    const [actualizarData, setactualizarData]=useState('')

  let query = new URLSearchParams(useLocation().search);
  let tokenCons = JSON.parse(query.get('token'));
  let location = useLocation();
  useEffect(() => {
    // Google Analytics
    localStorage.setItem('tokenReact',tokenCons)
  }, [location]);

    //token
  useEffect(()=>{
    //console.log(tokenCons,'tokenConstokenCons')
    const url = UserTokenURL()
    // Configurar la cabecera con el token JWT
    const headers = {
      Authorization: `Bearer ${tokenCons}`,
    };

    // Realiza la petición con Axios
    axios.get(url, { headers })
    .then(response => {      

      // Si decides actualizar el localStorage, primero elimina los datos antiguos si es necesario
      localStorage.removeItem('usuarioInfo');
      console.log(localStorage.getItem('usuarioInfo'), 'antes data user')
      // Guarda los nuevos datos
      localStorage.setItem('usuarioInfo', JSON.stringify(response.data.user_data));
    })
    .catch(error => {
      console.error('Error al autenticar al usuario:', error);
      //seterrorEndpoint(true)
    });
  },[])

    useEffect(()=>{
        setloading(false)
        postPrincipalFormasFarmaceuticas().then((res)=>{
            setloading(true)
            if(res.data.data){
                setdataFormasFarmaceuticas(res.data.data)
            }
        })
    },[actualizarData])

    const handleOnsubmitBuscar=(e)=>{
        e.preventDefault()
        const buscar={
            'FrmCod': e.target.codigo.value, 
            'FrmDsc': e.target.descripcion.value    
        }
        setloading(false)
        postPrincipalFormasFarmaceuticas(buscar).then((res)=>{
            setloading(true)
            if(res.data.data){
                setdataFormasFarmaceuticas(res.data.data)
            }
        })
    }

    const handleOnclickCrear=()=>{
        setmodalOnCrearFormasFarmaceuticas(true)
    }

    const handleOnclickConsultar=(item)=>{
        setdataUnaFormaFarmaceutica(item)
        setmodalOnConsultarFormasFarmaceuticas(true)
    }

    const handleOnclickModificar=(item)=>{
      setdataUnaFormaFarmaceutica(item)
      setmodalOnModificarFormasFarmaceuticas(true)
    }

    const handleOnclickEliminar=(item)=>{
      setdataUnaFormaFarmaceutica(item)
      setmodalOnEliminarFormasFarmaceuticas(true)
    }
  return (
    <>
      <div className="">
        <div className=" text-2xl text-[#9e56fe] font-medium pb-3">
          Formas Farmaceuticas
        </div>

        <form onSubmit={handleOnsubmitBuscar}>
          <div className="flex ">
            <div className="mb-3 xl:w-96">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium text-base	"
              >
                Código
              </label>
              <div className="flex">
                <input
                  name="codigo"
                  type="text"
                  className="form-control  block w-full  px-3 py-0.5  text-base font-normal
                              text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300
                              rounded transition ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none  "
                  id="exampleFormControlInput1"
                  placeholder=""
                  autoComplete='off'
                />
              </div>
            </div>
            <div className="mb-3 xl:w-96 px-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium text-base	"
              >
                Descripción
              </label>
              <div className="flex">
                <input
                  name="descripcion"
                  type="text"
                  className="form-control  block w-full  px-3 py-0.5  text-base font-normal
                              text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300
                              rounded transition ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none  "
                  id="exampleFormControlInput1"
                  placeholder=""
                  autoComplete='off'
                />
                <div className="px-3">
                  <button
                    type="submit"
                    className="inline-block px-6 py-1.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                  >
                    Buscar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form >
        <div className="flex ">
          
        <button
        onClick={handleOnclickCrear}
        type="button"
        className="inline-block px-6 py-1.5 bg-violet-600 text-white font-medium text-xs leading-tight uppercase  rounded shadow-md hover:bg-violet-700 hover:shadow-lg focus:bg-violet-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-violet-800 active:shadow-lg transition duration-150 ease-in-out"
      >
        Crear
      </button>
      
      </div>
        <div className="flex flex-col">
          <div className="overflow-x-auto md:overflow-x-visible sm:overflow-x-visible">
            <div className="py-2 inline-block min-w-full">
              <div className="overflow-auto md:overflow-visible">
                <table className="min-w-full text-center bg-gray-200">
                  <thead className=" ">
                    <tr>
                      <th></th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900  py-2 bg-gray-200"
                      >                        
                      </th>         
                      
                                
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Código Forma
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Descripción Forma
                      </th>
                             
                    </tr>
                  </thead>
                  <tbody >
                    {
                        loading?
                        dataFormasFarmaceuticas.map((item,index)=>(
                            <tr className=" divide-y divide-slate-700 " key={index}>
                        <td></td>
                        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                            <button className='mx-2' title="Editar" onClick={()=>handleOnclickModificar(item)}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30">
                                    <circle cx="12" cy="12" r="12" fill="#2196F3" />
                                    <path d="M7.75 15.5v-1.92l5.61-5.61 1.92 1.92-5.61 5.61H7.75zm7.88-6.27l-1.92-1.92 1.06-1.06a.75.75 0 011.06 0l.92.92a.75.75 0 010 1.06l-1.06 1.06z" fill="#FFF"/>
                                </svg>
                            </button>

                            <button className='mx-2' title="Consultar" onClick={()=>handleOnclickConsultar(item)}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30">
                                    <circle cx="12" cy="12" r="12" fill="#4CAF50" />
                                    <path d="M10.5 5a5.5 5.5 0 014.36 8.91l3.32 3.32a.75.75 0 01-1.06 1.06l-3.32-3.32A5.5 5.5 0 1110.5 5zm0 1.5a4 4 0 100 8 4 4 0 000-8z" fill="#FFF"/>
                                </svg>
                            </button>

                            <button className='mx-2' title="Eliminar" onClick={()=>handleOnclickEliminar(item)}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30">
                                    <circle cx="12" cy="12" r="12" fill="#F44336" />
                                    <path d="M15.5 8.5H8.5v9a1 1 0 001 1h5a1 1 0 001-1v-9zM10 18v-7h1v7h-1zm3 0v-7h1v7h-1zM9 6.5V6h6v.5h3v1H6v-1h3z" fill="#FFF"/>
                                </svg>
                            </button>
                        </td>
                        
                        
                        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">                          
                          {item.FrmCod}
                        </td>
                        <td className="text-xs text-gray-900 font-medium px-3 py-2 text-left whitespace-pre-wrap">
                        {item.FrmDsc}
                        </td>
                      </tr> 
                        ))
                        :
                        <tr className="divide-y divide-slate-700 ">
                        <td></td>
                        <td></td>                        
                        <td>
                          <Loading />
                        </td>
                        <td></td>                        
                      </tr>
                    }
                 
                   </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modalOnCrearFormasFarmaceuticas? <ModalCrearFormasFarmaceuticas setmodalOnCrearFormasFarmaceuticas={setmodalOnCrearFormasFarmaceuticas} setactualizarData={setactualizarData}/>:null}
      {modalOnConsultarFormasFarmaceuticas? <ModalConsultarFormasFarmaceuticas setmodalOnConsultarFormasFarmaceuticas={setmodalOnConsultarFormasFarmaceuticas} dataUnaFormaFarmaceutica={dataUnaFormaFarmaceutica}/>:null}
      {modalOnModificarFormasFarmaceuticas? <ModalModificarFormasFarmaceuticas dataUnaFormaFarmaceutica={dataUnaFormaFarmaceutica} setmodalOnModificarFormasFarmaceuticas={setmodalOnModificarFormasFarmaceuticas} setactualizarData={setactualizarData}/>:null}
      {modalOnEliminarFormasFarmaceuticas? <ModalConfirmarEliminarFormasFarmaceuticasYViasAplicacion setmodalOnEliminarFormasFarmaceuticas={setmodalOnEliminarFormasFarmaceuticas} dataUnaFormaFarmaceutica={dataUnaFormaFarmaceutica} setactualizarData={setactualizarData}/>:null}
      
    </>
  )
}

export default FormasFarmaceuticasPrincipal